<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
            <div class="section">

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a @click="$router.push('/clients')">Chatbots</a></li>
                        <li><a @click="$router.go()">{{clientName}}</a></li>
                        <li class="is-active"><a href="#" aria-current="page">Intenciones</a></li>
                    </ul>
                </nav>

                <div class="button is-primary is-left" @click="storeIntent">
                    <span class="icon"><i class="fas fa-plus"></i></span>
                    <span class="is-capitalized">Nueva Intención</span>
                </div>

                <br><br><br>
                <div class="field has-addons">

                    <!-- search icon -->
                    <div class="control">
                        <a class="button">
                            <span class="icon"><i class="fas fa-search"></i></span>
                        </a>
                    </div>

                    <!-- input  -->
                    <div class="control is-expanded">
                        <input class="input" type="text" placeholder="Buscar intención (Esc para cancelar)"
                               v-model="textFilter"
                               v-on:keyup.esc="textFilter=null">
                    </div>

                </div>

                <br>
                <table class="table is-striped is-fullwidth">

                    <thead>
                    <tr>
                        <th class="is-capitalized">Nombre</th>
                        <th class="is-capitalized has-text-centered">#Frases</th>
                        <th class="is-capitalized has-text-centered">#MATCHOK / #MATCHKO</th>
                        <th class="is-capitalized has-text-centered">👍🏼 / 👎🏼</th>
                        <th class="table-button-column"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="intent in filteredIntents" :key="intent.idIntentIntent">
                        <td>{{intent.name}}</td>
                        <td class="has-text-centered">{{intent.phrases}}</td>
                        <td class="has-text-centered">{{intent.coincidences}} / {{intent.coincidencesKO}}</td>
                        <td class="has-text-centered is-rate">
                          <span>{{intent.rateOK}} / {{intent.rateKO}} |</span>
                          <span class="control">
                            <a v-if="intent.rate" :disabled="isDefault(intent) || isRate(intent)"  @click="toogleRate(intent)" class="button is-success" title="Desactivar">
                              <span class="icon"><i class="fas fa-toggle-on"></i></span>
                            </a>
                            <a  v-else :disabled="isDefault(intent) || isRate(intent)" @click="toogleRate(intent)" class="button" style="background-color: #E0E000" title="Activar">
                              <span class="icon"><i class="fas fa-toggle-off"></i></span>
                            </a>
                          </span>
                        </td>
                        <td>
                          <div class="field has-addons">
                            <p class="control">
                              <a @click="showSentences(intent)"
                                 class="button is-primary"
                                 title="Ver intención">
                                <span class="icon"><i class="fas fa-eye"></i></span>
                              </a>
                            </p>
                            <p class="control">
                              <a :disabled="isDefault(intent) || isRate(intent)" @click="updateIntent(intent)"
                                 class="button is-warning"
                                 title="Editar">
                                <span class="icon"><i class="fas fa-edit"></i></span>
                              </a>
                            </p>
                            <p class="control">
                              <a v-if="intent.active" :disabled="isDefault(intent)"  @click="toggleActive(intent)" class="button is-success" title="Desactivar">
                                <span class="icon"><i class="fas fa-toggle-on"></i></span>
                              </a>
                              <a  v-else :disabled="isDefault(intent)" @click="toggleActive(intent)" class="button" style="background-color: #E0E000" title="Activar">
                                <span class="icon"><i class="fas fa-toggle-off"></i></span>
                              </a>
                            </p>
                            <p class="control">
                              <a :disabled="isDefault(intent) || isRate(intent)" @click="deleteIntent(intent)"
                                 class="button is-danger"
                                 title="Eliminar">
                                <span class="icon"><i class="fas fa-trash-alt"></i></span>
                              </a>
                            </p>
                          </div>
                        </td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      textFilter: null,
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intents: []
    }
  },
  created () {
    this.api.post('/IntentGetList', {idClient: this.client}).then(response => {
      this.intents = response.intents
    })
    this.breadcrumbDetails()
  },
  computed: {
    filteredIntents () {
      let self = this

      return this.intents.filter(function (intent) {
        if (!self.textFilter) return true

        if ((intent.name.search(self.textFilter) > -1) || (intent.name.toLowerCase().search(self.textFilter) > -1)) {
          return true
        }

        if ((intent.description.search(self.textFilter) > -1) || (intent.description.toLowerCase().search(self.textFilter) > -1)) {
          return true
        }
      })
    }
  },
  methods: {
    reloadIntents () {
      this.api.post('/IntentGetList', {idClient: this.client}).then(response => {
        this.intents = response.intents
      })
    },
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
    },
    isDefault (intent) {
      return intent.name.toLowerCase() === 'default'
    },
    isRate (intent) {
      return intent.name.toLowerCase() === "h. valoración";
    },
    storeIntent () {
      this.$router.push('/clients/' + this.client + '/intents/store')
    },
    showSentences (intent) {
      this.$router.push('/clients/' + this.client + '/intents/' + intent.idIntent + '/sentences')
    },
    updateIntent (intent) {
      if (this.isDefault(intent) || this.isRate(intent)) {
        return
      }
      this.$router.push('/clients/' + this.client + '/intents/' + intent.idIntent + '/update')
    },
    toggleActive (intent) {
      if (this.isDefault(intent)) {
        return
      }

      this.api.post('/IntentActive', {idIntent: intent.idIntent, active: intent.active ? 0 : 1}).then(() => {
        this.reloadIntents();
      })
    },
    toogleRate (intent) {
      if (this.isDefault(intent) || this.isRate(intent)) {
        return;
      }
      console.log(intent.idIntent)
      this.api.post('/IntentRate', {idIntent: intent.idIntent, rate: intent.rate ? 0 : 1}).then(() => {
        this.reloadIntents();
      })
    },
    deleteIntent (intent) {
      if (this.isDefault(intent) || this.isRate(intent)) {
        return
      }

      let message = '¿Estás seguro de borrar la intención ' + intent.name + '?'

      this.dialog.confirm({message}).then(() => {
        this.api.post('/IntentDelete', intent).then(() => {
          this.reloadIntents();
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/Intents.vue